import selectors from '../../../rootSelectors';
import { activateNextButton, blockScreen, unblockScreen } from '../../../common/screen/screenActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../common/avatar/avatarActions';
import {
    selectResponse, clearResponses, highlightMazeResponse, dehighlightMazeResponses,
} from '../../mazeActions';
import { MODEL } from '../../../constants/assessmentItemType';

export const playDirectionsScript = (modelInstructions) => (dispatch) => dispatch(playAvatarAudio(modelInstructions.directionInstruction));

export const playModelScript = (modelInstructions) => (dispatch, getState) => {
    const state = getState();
    const question = selectors.getMazeQuestionItems(state, MODEL)[0];
    const { possibleResponses } = question;
    return dispatch(playAvatarAudio(modelInstructions.modelInstructionStart))
        .then(() => {
            dispatch(highlightMazeResponse(question.id, possibleResponses[0].id));
            return dispatch(playAvatarAudio(modelInstructions.modelOptionOne));
        }).then(() => {
            dispatch(highlightMazeResponse(question.id, possibleResponses[1].id));
            return dispatch(playAvatarAudio(modelInstructions.modelOptionTwo));
        }).then(() => {
            dispatch(highlightMazeResponse(question.id, possibleResponses[2].id));
            return dispatch(playAvatarAudio(modelInstructions.modelOptionThree));
        })
        .then(() => {
            dispatch(clearResponses());
            return dispatch(playAvatarAudio(modelInstructions.modelInstructionEnd));
        });
};

export const firstIncorrectResponse = (modelInstructions) => (dispatch) => dispatch(playAvatarAudio(modelInstructions.modelIncorrectResponse, 0))
    .then(() => {
        dispatch(dehighlightMazeResponses());
        dispatch(unblockScreen());
    });

export const secondIncorrectResponse = (modelInstructions) => (dispatch) => dispatch(playAvatarAudio(modelInstructions.modelSecondIncorrectResponse, 0))
    .then(() => {
        dispatch(activateNextButton());
        dispatch(setAvatarInstructions(modelInstructions.clickOk));
        return dispatch(playAvatarAudio(modelInstructions.clickOk));
    }).then(() => {
        dispatch(unblockScreen());
    });

export const incorrectResponseSelected = (questionId, correctResponse, isFirstAttempt, modelInstructions) => (dispatch) => {
    dispatch(highlightMazeResponse(questionId, correctResponse));
    return isFirstAttempt
        ? dispatch(secondIncorrectResponse(modelInstructions))
        : dispatch(firstIncorrectResponse(modelInstructions));
};

export const correctResponseSelected = (modelInstructions) => (dispatch) => dispatch(playAvatarAudio(modelInstructions.modelCorrectResponse, 0))
    .then(() => {
        dispatch(activateNextButton());
        dispatch(setAvatarInstructions(modelInstructions.clickOk));
        return dispatch(playAvatarAudio(modelInstructions.clickOk));
    }).then(() => {
        dispatch(unblockScreen());
    });

export const onResponseSelected = (questionId, responseId, modelInstructions) => (dispatch, getStore) => {
    const state = getStore();
    const correctResponse = selectors.getMazeCorrectResponse(state, MODEL, questionId);
    const isFirstAttempt = selectors.getIsMazeFirstAttemptMade(state);
    dispatch(blockScreen());
    dispatch(selectResponse(questionId, responseId));
    if (correctResponse === responseId) {
        return dispatch(correctResponseSelected(modelInstructions));
    }
    return dispatch(incorrectResponseSelected(questionId, correctResponse, isFirstAttempt, modelInstructions));
};

export default onResponseSelected;
